type ExitSlipSession =
  | {
      readonly isComplete: boolean | null | undefined;
    }
  | null
  | undefined;

type ClassExitSlipLike =
  | {
      readonly learnosityExitSlipSessions: ReadonlyArray<ExitSlipSession> | null | undefined;
    }
  | null
  | undefined;

export const exitSlipCompletedCount = (classExitSlips: ReadonlyArray<ClassExitSlipLike> | null | undefined): string => {
  const slips = classExitSlips ?? [];
  const completed = slips.filter(slip => slip?.learnosityExitSlipSessions?.[0]?.isComplete === true).length;
  return completed === 0 ? '0' : `${completed}/${slips.length}`;
};
